import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IQuery, PaginatedResults } from '@utils';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { API_URL } from '../../core.tokens';
import { PlanCategory } from '../../models/plan.model';


@Injectable()
export class PlanCategoriesCoreService {

  constructor(
    protected http: HttpClient,
    @Inject(API_URL) protected apiUrl: string
  ) { }

  getByQuery(query: IQuery) {
    return this.http.post<PaginatedResults<PlanCategory>>(`${this.apiUrl}/plan-category/query`, query).pipe(first());
  }

  getById(id: number): Observable<PlanCategory> {
    return this.http.get<PlanCategory>(`${this.apiUrl}/plan-category/${id}`).pipe(first());
  }
}
